// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DEMaU","inner":"styles_inner__1j7T5","right":"styles_right__cXfU9","close":"styles_close__2fuEJ","footer":"styles_footer__1Vrww"};